import {
  ArticleSidebarHeader,
  ArticleSidebarLink,
  ArticleSidebarLinks,
} from 'routes/components/Article/ArticleSidebar'

import zapierIcon from './icon_zapier.svg'
import { LINKS } from 'routes/constants'

export function HowWeAreDifferentSidebar() {
  return (
    <>
      <ArticleSidebarHeader>One-to-one comparisons</ArticleSidebarHeader>

      <ArticleSidebarLinks>
        <ArticleSidebarLink href={`${LINKS.ARTICLES}/comparisons/zapier`}>
          Integration.app vs{' '}
          <span className={'whitespace-nowrap'}>
            Zapier{' '}
            <img
              src={zapierIcon.src}
              alt={'Zapier Icon'}
              className={'w-4 ml-1 h-auto inline-block'}
            />
          </span>
        </ArticleSidebarLink>
      </ArticleSidebarLinks>
    </>
  )
}
